var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.69,
    height: 30.69
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2376",
    d: "M6.8 18.546l-1.068 3.988-3.9.083a15.372 15.372 0 01-.113-14.329l3.476.637 1.523 3.455a9.158 9.158 0 00.086 6.166z",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2377",
    d: "M30.422 12.478a15.339 15.339 0 01-5.47 14.833l-4.378-.223-.62-3.868a9.145 9.145 0 003.935-4.67h-8.205v-6.071h14.74z",
    fill: "#518ef8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2378",
    d: "M24.951 27.31a15.35 15.35 0 01-23.123-4.695l4.973-4.071a9.126 9.126 0 0013.151 4.673z",
    fill: "#28b446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2379",
    d: "M25.14 3.533L20.169 7.6a9.125 9.125 0 00-13.453 4.778l-5-4.093A15.348 15.348 0 0125.14 3.533z",
    fill: "#f14336"
  })));
};
export default SvgGoogleIcon;